/* Find stores panel for the mobile menu (mm-mobile-menu). */
(function () {
  if (window.__mmFindStores) return;
  window.__mmFindStores = true;

  var CSV_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQLxaWrIhj8_TJ7-Yz6IaSWwH7dElTAo10XYOSf8EjDz4bvZ2X4pHndUr67dLgMMm4nHsIBcrRmjTp0/pub?gid=0&single=true&output=csv';
  var DAY = 24 * 60 * 60 * 1000;
  var LIST_KEY = 'mmStockists.v1';
  var GEO_KEY = 'mmStockistsGeo.v1';
  var TRIGGER = 'a[href*="/pages/stockists"]';

  /* ---------- storage ---------- */
  function load(key) {
    try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }
  function save(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  /* ---------- text helpers ---------- */
  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/ø/g, 'o').replace(/æ/g, 'ae').replace(/ß/g, 'ss')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\s+(municipality|kommune|city|stad|gemeente)$/, '')
      .replace(/[^a-z0-9' -]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  var CITY_ALIASES = {
    'wien': 'vienna', 'lissabon': 'lisbon', 'lisboa': 'lisbon', 'warzaw': 'warsaw', 'warszawa': 'warsaw',
    'teipei': 'taipei', 'taipei city': 'taipei', 'goteborg': 'gothenburg', 'milano': 'milan',
    'cincinatti': 'cincinnati', 'den haag': 'the hague', "'s-gravenhage": 'the hague', 'winnepeg': 'winnipeg',
    'kobenhavn': 'copenhagen', 'frederiksberg': 'copenhagen', 'an arbor': 'ann arbor', 'valance': 'valence',
    'koln': 'cologne', 'munchen': 'munich', 'new york city': 'new york', 'manhattan': 'new york',
    'brooklyn': 'new york', 'bucuresti': 'bucharest', 'athina': 'athens', 'roma': 'rome', 'praha': 'prague',
    'firenze': 'florence', 'antwerpen': 'antwerp', 'bruxelles': 'brussels', 'brussel': 'brussels',
    'seoul special city': 'seoul', 'tokyo metropolis': 'tokyo', 'arhus': 'aarhus', 'paris 1er': 'paris',
    'lisbonne': 'lisbon', 'londres': 'london', 'wenen': 'vienna', 'kopenhagen': 'copenhagen', 'copenhague': 'copenhagen'
  };
  function cityKey(s) {
    var k = norm(String(s || '').split(',')[0]);
    return CITY_ALIASES[k] || k;
  }

  var COUNTRY_ALIASES = {
    'faroe island': 'FO', 'faroe islands': 'FO', 'lichtenstein': 'LI', 'northern ireland': 'GB', 'england': 'GB',
    'scotland': 'GB', 'wales': 'GB', 'uk': 'GB', 'great britain': 'GB', 'usa': 'US', 'us': 'US',
    'united states of america': 'US', 'holland': 'NL', 'the netherlands': 'NL', 'czech republic': 'CZ',
    'korea': 'KR', 'republic of korea': 'KR'
  };
  var LANGS = ['en', 'da', 'de', 'sv', 'nb', 'fr', 'nl', 'it', 'es'];
  var regionNames = null;
  try { regionNames = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (e) {}
  var countryIndex = null;
  function countryCode(name) {
    var k = norm(name);
    if (!k) return '';
    if (COUNTRY_ALIASES[k]) return COUNTRY_ALIASES[k];
    if (!countryIndex) {
      countryIndex = {};
      // English first, then other languages so visitors can type e.g. "Danmark" or "Deutschland"
      LANGS.forEach(function (lang) {
        var names;
        try { names = new Intl.DisplayNames([lang], { type: 'region' }); } catch (e) { return; }
        var A = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var SKIP = ' AN BU CS DD DY EU EZ FX HV NH NT QO RH SU TP UK UN VD YD YU ZR XA XB ';
        for (var i = 0; i < 26; i++) for (var j = 0; j < 26; j++) {
          var code = A[i] + A[j], label;
          if (SKIP.indexOf(' ' + code + ' ') >= 0) continue;
          try { label = names.of(code); } catch (e) { label = null; }
          if (label && label !== code && !countryIndex[norm(label)]) countryIndex[norm(label)] = code;
        }
      });
    }
    return countryIndex[k] || '';
  }
  function countryName(code) {
    if (!code) return '';
    try { return (regionNames && regionNames.of(code)) || code; } catch (e) { return code; }
  }

  function cleanLink(url) {
    url = String(url || '').trim();
    if (!url) return '';
    if (!/^https?:\/\//i.test(url)) url = 'https://' + url.replace(/^\/+/, '');
    try {
      var u = new URL(url);
      ['srsltid', 'gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid', '_gl', 'campaignid', 'fbclid'].forEach(function (p) { u.searchParams.delete(p); });
      Array.from(u.searchParams.keys()).forEach(function (p) { if (/^utm_/i.test(p)) u.searchParams.delete(p); });
      return u.toString();
    } catch (e) { return ''; }
  }

  /* ---------- data ---------- */
  function parseCSV(text) {
    var rows = [], row = [], field = '', q = false;
    for (var i = 0; i < text.length; i++) {
      var c = text[i];
      if (q) {
        if (c === '"') { if (text[i + 1] === '"') { field += '"'; i++; } else q = false; }
        else field += c;
      } else if (c === '"') q = true;
      else if (c === ',') { row.push(field); field = ''; }
      else if (c === '\n' || c === '\r') {
        if (c === '\r' && text[i + 1] === '\n') i++;
        row.push(field); rows.push(row); row = []; field = '';
      } else field += c;
    }
    if (field || row.length) { row.push(field); rows.push(row); }
    return rows;
  }

  function toStores(text) {
    var rows = parseCSV(text);
    var head = (rows.shift() || []).map(norm);
    var col = function (name, fallback) { var i = head.indexOf(name); return i < 0 ? fallback : i; };
    var ci = col('country', 0), ti = col('title', 1), yi = col('city', 2), li = col('link', 3);
    var stores = [];
    rows.forEach(function (r) {
      var title = (r[ti] || '').replace(/\s+/g, ' ').trim();
      var country = (r[ci] || '').trim();
      if (!title || !country) return;
      var city = (r[yi] || '').replace(/\s+/g, ' ').trim();
      var cityNorm = norm(city);
      var kind = 'city';
      if (!cityNorm || cityNorm === 'www' || cityNorm === 'online') kind = cityNorm ? 'online' : 'none';
      else if (cityNorm === 'multiple') kind = 'multiple';
      if (kind === 'city') city = city.split(',').map(function (p) { p = p.trim(); return p.charAt(0).toUpperCase() + p.slice(1); }).join(', ');
      stores.push({
        title: title,
        country: country,
        cc: countryCode(country),
        city: kind === 'city' ? city : '',
        key: kind === 'city' ? cityKey(city) : '',
        kind: kind,
        link: cleanLink(r[li])
      });
    });
    return stores;
  }

  var listPromise = null;
  function getStores() {
    var cached = load(LIST_KEY);
    var fresh = cached && cached.csv && Date.now() - cached.t < DAY;
    if (fresh) return Promise.resolve(toStores(cached.csv));
    if (!listPromise) {
      listPromise = fetch(CSV_URL, { cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (csv) {
          if (!/country/i.test(csv.slice(0, 200))) throw new Error('Unexpected CSV');
          save(LIST_KEY, { t: Date.now(), csv: csv });
          return toStores(csv);
        })
        .catch(function (err) {
          listPromise = null;
          if (cached && cached.csv) return toStores(cached.csv); // stale is better than nothing
          throw err;
        });
    }
    return listPromise;
  }

  /* ---------- location ---------- */
  function locate() {
    return new Promise(function (resolve, reject) {
      if (!navigator.geolocation) return reject(new Error('unsupported'));
      navigator.geolocation.getCurrentPosition(resolve, reject, { enableHighAccuracy: false, timeout: 15000, maximumAge: 10 * 60 * 1000 });
    }).then(function (pos) {
      var c = pos.coords;
      var url = 'https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=' + c.latitude + '&longitude=' + c.longitude + '&localityLanguage=en';
      return fetch(url).then(function (r) { if (!r.ok) throw new Error('geocode'); return r.json(); });
    }).then(function (g) {
      var names = [g.city, g.locality, g.principalSubdivision];
      ((g.localityInfo && g.localityInfo.administrative) || []).forEach(function (a) {
        if (a && a.adminLevel >= 6) names.push(a.name);
      });
      var keys = [];
      names.forEach(function (n) { var k = cityKey(n); if (k && keys.indexOf(k) < 0) keys.push(k); });
      var geo = { t: Date.now(), cc: g.countryCode || '', city: g.city || g.locality || '', keys: keys };
      save(GEO_KEY, geo);
      return geo;
    });
  }
  function savedGeo() {
    var g = load(GEO_KEY);
    return g && Date.now() - g.t < DAY ? g : null;
  }
  function permissionGranted() {
    if (!navigator.permissions || !navigator.permissions.query) return Promise.resolve(false);
    return navigator.permissions.query({ name: 'geolocation' })
      .then(function (s) { return s.state === 'granted'; })
      .catch(function () { return false; });
  }

  /* Turn typed text ("Copenhagen", "Germany", "Paris, France") into the same shape as a location */
  function resolveQuery(q, stores) {
    var cc = '', key = '', label = '';
    String(q || '').split(',').forEach(function (part) {
      part = part.trim();
      if (!part) return;
      var code = countryCode(part);
      if (code && !cc) cc = code;
      else if (!key) { key = cityKey(part); label = part; }
    });
    var keys = [];
    if (key) {
      stores.forEach(function (s) {
        if (!s.key || keys.indexOf(s.key) >= 0) return;
        if (cc && s.cc !== cc) return;
        if (s.key === key || (key.length >= 3 && s.key.indexOf(key) === 0)) keys.push(s.key);
      });
      var hits = stores.filter(function (s) { return keys.indexOf(s.key) >= 0; });
      if (hits.length) {
        if (keys.length === 1) {
          var best = hits.filter(function (h) { return norm(h.city.split(',')[0]) === h.key; })[0] || hits[0];
          label = best.city;
        }
        if (!cc) cc = hits[0].cc;
      }
    }
    if (label) label = label.charAt(0).toUpperCase() + label.slice(1);
    return {
      manual: true,
      cc: cc || (window.Shopify && window.Shopify.country) || '',
      city: key ? label : '',
      keys: keys.length ? keys : (key ? [key] : [])
    };
  }

  /* ---------- UI ---------- */
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function Panel(menu) {
    this.menu = menu;
    this.scroll = menu.querySelector('.mm-menu__scroll');
    this.details = menu.closest('details');
    this.geo = savedGeo();
    this.build();
    this.bind();
  }

  Panel.prototype.build = function () {
    var root = el('div', 'mm-stores');
    root.setAttribute('aria-hidden', 'true');
    root.id = 'mm-stores';

    this.locateBtn = this.locateButton();
    this.locateBtn.setAttribute('aria-hidden', 'true');
    this.locateBtn.tabIndex = -1;

    var body = this.buildBody();

    var foot = el('div', 'mm-stores__foot');
    this.backBtn = el('button', 'mm-stores__back', 'Back');
    this.backBtn.type = 'button';
    foot.appendChild(this.backBtn);

    root.appendChild(body);
    root.appendChild(foot);
    this.root = root;
    this.scroll.appendChild(root);
    this.menu.appendChild(this.locateBtn);
  };

  Panel.prototype.locateButton = function () {
    var b = el('button', 'mm-stores__locate', 'Find your local store');
    b.type = 'button';
    return b;
  };

  /* City + Country sections and the typed fallback field (shared by mobile and desktop) */
  Panel.prototype.buildBody = function () {
    var body = el('div', 'mm-stores__body');
    this.citySec = this.section('City');
    this.countrySec = this.section('Country');
    body.appendChild(this.citySec.root);
    body.appendChild(this.countrySec.root);

    // Shown when location can't be used: type a city and/or country instead
    var form = el('form', 'mm-stores__manual');
    form.setAttribute('role', 'search');
    form.hidden = true;
    var input = el('input', 'mm-stores__input');
    input.type = 'text';
    input.name = 'stores-q';
    input.placeholder = 'Enter city and/or country';
    input.setAttribute('aria-label', 'City and/or country');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'words');
    input.setAttribute('enterkeyhint', 'search');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    var go = el('button', 'mm-stores__go', 'Search');
    go.type = 'submit';
    form.appendChild(input);
    form.appendChild(go);
    this.manualForm = form;
    this.manualInput = input;
    this.citySec.root.appendChild(form);

    // Suggestions shown while typing (cities and countries we have stores in)
    var list = el('ul', 'mm-stores__suggest');
    list.id = (this.idPrefix || 'mm') + '-stores-suggest';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Suggestions');
    list.hidden = true;
    input.setAttribute('aria-controls', list.id);
    this.suggestList = list;
    this.citySec.root.appendChild(list);
    return body;
  };

  Panel.prototype.section = function (label) {
    var root = el('section', 'mm-stores__section');
    var h = el('h2', 'mm-stores__heading', label);
    var where = el('span', 'mm-stores__where');
    h.appendChild(where);
    var content = el('div', 'mm-stores__content');
    root.appendChild(h);
    root.appendChild(content);
    return { root: root, where: where, content: content };
  };

  Panel.prototype.bind = function () {
    var self = this;
    this.menu.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest(TRIGGER);
      if (!a || !self.menu.contains(a) || self.root.contains(a)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      e.stopPropagation();
      self.trigger = a;
      self.open();
    }, true);
    this.backBtn.addEventListener('click', function () { self.close(true); });
    this.bindFinder();
    this.menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.isOpen) {
        e.stopPropagation();
        if (self.suggestItems && self.suggestItems.length) { self.hideSuggest(); return; }
        self.close(true);
      }
    }, true);
    if (this.details) {
      new MutationObserver(function () {
        if (!self.details.hasAttribute('open') && self.isOpen) {
          clearTimeout(self.resetTimer);
          self.resetTimer = setTimeout(function () { self.close(false); }, 450);
        }
      }).observe(this.details, { attributes: true, attributeFilter: ['open'] });
    }
  };

  Panel.prototype.bindFinder = function () {
    var self = this;
    var input = this.manualInput;
    this.locateBtn.addEventListener('click', function () { self.findMe(); });
    this.manualForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      self.hideSuggest();
      self.searchManual(input.value);
    });

    input.addEventListener('input', function () { self.updateSuggest(); });
    input.addEventListener('focus', function () { if (input.value.trim()) self.updateSuggest(); });
    input.addEventListener('blur', function () { setTimeout(function () { self.hideSuggest(); }, 150); });
    input.addEventListener('keydown', function (e) {
      var n = self.suggestItems ? self.suggestItems.length : 0;
      if (e.key === 'ArrowDown' && n) { e.preventDefault(); self.moveSuggest(1); }
      else if (e.key === 'ArrowUp' && n) { e.preventDefault(); self.moveSuggest(-1); }
      else if (e.key === 'Enter' && n && self.suggestActive >= 0) { e.preventDefault(); e.stopPropagation(); self.pickSuggest(self.suggestActive); }
      else if (e.key === 'Tab' && n && !e.shiftKey && input.value.trim()) { e.preventDefault(); self.pickSuggest(self.suggestActive >= 0 ? self.suggestActive : 0); }
      else if (e.key === 'Escape' && n) { e.preventDefault(); self.escapedSuggest = true; self.hideSuggest(); }
    });
    // Desktop menu closes on Escape keyup: swallow it when Escape only closed the suggestions
    input.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && self.escapedSuggest) { e.stopPropagation(); self.escapedSuggest = false; }
    });
    this.suggestList.addEventListener('mousedown', function (e) { e.preventDefault(); }); // keep focus in the field
    this.suggestList.addEventListener('click', function (e) {
      var li = e.target.closest && e.target.closest('.mm-stores__suggestion');
      if (li) self.pickSuggest(Number(li.getAttribute('data-i')));
    });
  };

  /* ---------- autocomplete ---------- */
  function startsWord(term, q) {
    if (term.indexOf(q) === 0) return 0;              // starts with the typed text
    var words = term.split(' ');
    for (var i = 1; i < words.length; i++) if (words[i].indexOf(q) === 0) return 1; // a later word does
    return -1;
  }

  function buildSuggestIndex(stores) {
    var cities = {}, countries = {};
    stores.forEach(function (s) {
      if (s.cc && !countries[s.cc]) countries[s.cc] = { type: 'country', cc: s.cc, label: countryName(s.cc), main: norm(countryName(s.cc)), terms: [], n: 0 };
      if (s.cc) countries[s.cc].n++;
      if (s.kind !== 'city' || !s.key) return;
      var c = cities[s.key + '|' + s.cc];
      if (!c) c = cities[s.key + '|' + s.cc] = { type: 'city', key: s.key, cc: s.cc, label: s.city, terms: [s.key], n: 0 };
      c.n++;
      var spelled = norm(s.city.split(',')[0]);
      if (spelled === s.key) c.label = s.city;          // prefer the spelling that matches the key (Vienna over Wien)
      if (c.terms.indexOf(spelled) < 0) c.terms.push(spelled);
      c.main = norm(c.label.split(',')[0]);
    });
    Object.keys(CITY_ALIASES).forEach(function (alias) {
      Object.keys(cities).forEach(function (id) {
        var c = cities[id];
        if (CITY_ALIASES[alias] === c.key && c.terms.indexOf(alias) < 0) c.terms.push(alias);
      });
    });
    Object.keys(countries).forEach(function (cc) {
      var c = countries[cc];
      LANGS.forEach(function (lang) {
        try { var n = norm(new Intl.DisplayNames([lang], { type: 'region' }).of(cc)); if (n && c.terms.indexOf(n) < 0) c.terms.push(n); } catch (e) {}
      });
      Object.keys(COUNTRY_ALIASES).forEach(function (a) { if (COUNTRY_ALIASES[a] === cc && a.length > 2 && c.terms.indexOf(a) < 0) c.terms.push(a); });
    });
    var all = [];
    Object.keys(countries).forEach(function (k) { all.push(countries[k]); });
    Object.keys(cities).forEach(function (k) { all.push(cities[k]); });
    return all;
  }

  function suggestFor(index, raw) {
    // "Paris, Fr" -> suggest within the text after the last comma, keep what came before
    var parts = String(raw || '').split(',');
    var q = norm(parts.pop());
    var prefix = parts.length ? parts.join(',').trim() : '';
    if (!q) return [];
    var prefixCC = prefix ? countryCode(prefix) : '';
    var prefixCity = prefix && !prefixCC ? cityKey(prefix) : '';
    var hits = [];
    index.forEach(function (item) {
      if (prefix && item.type === 'city' && (prefixCity || (prefixCC && item.cc !== prefixCC))) return;
      if (prefix && item.type === 'country' && prefixCC) return;
      // The shown name always counts; other spellings (Wien, Danmark, Tyskland...) once 3+ letters are typed
      var best = startsWord(item.main, q);
      if (best < 0 && q.length >= 3) {
        item.terms.forEach(function (t) { var r = startsWord(t, q); if (r >= 0 && (best < 0 || r + 2 < best)) best = r + 2; });
      }
      if (best >= 0) hits.push({ item: item, score: best });
    });
    hits.sort(function (a, b) {
      return (a.score - b.score) || ((a.item.type === 'country' ? 0 : 1) - (b.item.type === 'country' ? 0 : 1)) ||
        (b.item.n - a.item.n) || a.item.label.localeCompare(b.item.label, 'en');
    });
    return hits.slice(0, 6).map(function (h) {
      var it = h.item;
      var value = it.type === 'city' ? it.label.split(',')[0] + ', ' + countryName(it.cc) : it.label;
      if (prefix && it.type === 'country') value = prefix + ', ' + it.label;
      return { label: it.label, meta: it.type === 'city' ? countryName(it.cc) : (it.n === 1 ? '1 store' : it.n + ' stores'), value: value };
    });
  }

  Panel.prototype.updateSuggest = function () {
    var self = this;
    var q = this.manualInput.value;
    if (!q.trim()) { this.hideSuggest(); return; }
    getStores().then(function (stores) {
      if (self.manualInput.value !== q) return;         // typed on since
      if (self.suggestStores !== stores.length || !self.suggestIndex) {
        self.suggestIndex = buildSuggestIndex(stores);
        self.suggestStores = stores.length;
      }
      self.renderSuggest(suggestFor(self.suggestIndex, q));
    }).catch(function () {});
  };

  Panel.prototype.renderSuggest = function (items) {
    var list = this.suggestList, input = this.manualInput, prefix = list.id;
    this.suggestItems = items;
    this.suggestActive = -1;
    input.removeAttribute('aria-activedescendant');
    if (!items.length) { this.hideSuggest(); return; }
    var frag = document.createDocumentFragment();
    items.forEach(function (it, i) {
      var li = el('li', 'mm-stores__suggestion');
      li.id = prefix + '-' + i;
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.setAttribute('data-i', i);
      li.appendChild(el('span', 'mm-stores__suggestion-label', it.label));
      li.appendChild(el('span', 'mm-stores__meta', it.meta));
      frag.appendChild(li);
    });
    list.replaceChildren(frag);
    list.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  };

  Panel.prototype.moveSuggest = function (dir) {
    var n = this.suggestItems.length;
    this.suggestActive = (this.suggestActive + 1 + dir + n + 1) % (n + 1) - 1; // wraps through "nothing selected"
    var self = this;
    Array.prototype.forEach.call(this.suggestList.children, function (li, i) {
      var on = i === self.suggestActive;
      li.classList.toggle('is-active', on);
      li.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (this.suggestActive >= 0) this.manualInput.setAttribute('aria-activedescendant', this.suggestList.id + '-' + this.suggestActive);
    else this.manualInput.removeAttribute('aria-activedescendant');
  };

  Panel.prototype.pickSuggest = function (i) {
    var it = this.suggestItems && this.suggestItems[i];
    if (!it) return;
    this.manualInput.value = it.value;
    this.hideSuggest();
    this.searchManual(it.value);
  };

  Panel.prototype.hideSuggest = function () {
    if (!this.suggestList) return;
    this.suggestItems = [];
    this.suggestActive = -1;
    this.suggestList.hidden = true;
    this.suggestList.replaceChildren();
    this.manualInput.setAttribute('aria-expanded', 'false');
    this.manualInput.removeAttribute('aria-activedescendant');
  };

  Panel.prototype.open = function () {
    clearTimeout(this.resetTimer);
    this.isOpen = true;
    this.scroll.scrollTop = 0;
    this.root.scrollTop = 0;
    this.menu.classList.add('is-stores');
    this.root.setAttribute('aria-hidden', 'false');
    this.locateBtn.setAttribute('aria-hidden', 'false');
    this.locateBtn.tabIndex = 0;
    var self = this;
    this.render();
    setTimeout(function () { try { self.locateBtn.focus({ preventScroll: true }); } catch (e) {} }, 350);
    if (!this.geo) {
      permissionGranted().then(function (ok) { if (ok && self.isOpen && !self.geo) self.findMe(); });
    }
  };

  Panel.prototype.close = function (restoreFocus) {
    this.isOpen = false;
    this.menu.classList.remove('is-stores');
    this.root.setAttribute('aria-hidden', 'true');
    this.locateBtn.setAttribute('aria-hidden', 'true');
    this.locateBtn.tabIndex = -1;
    if (restoreFocus && this.trigger) { try { this.trigger.focus({ preventScroll: true }); } catch (e) {} }
  };

  Panel.prototype.findMe = function () {
    if (this.locating) return;
    var self = this;
    this.locating = true;
    this.locateBtn.classList.add('is-loading');
    this.locateBtn.setAttribute('aria-busy', 'true');
    this.note = '';
    locate().then(function (geo) {
      self.geo = geo;
      self.manualForm.hidden = true;
    }).catch(function (err) {
      self.geo = null;
      self.note = err && err.code === 1 ? 'Location is turned off for this site' : 'We couldn’t find your location';
      self.manualForm.hidden = false;
    }).then(function () {
      self.locating = false;
      self.locateBtn.classList.remove('is-loading');
      self.locateBtn.removeAttribute('aria-busy');
      self.render(true);
    });
  };

  Panel.prototype.searchManual = function (q) {
    q = String(q || '').trim();
    if (!q) { this.manualInput.focus(); return; }
    var self = this;
    try { this.manualInput.blur(); } catch (e) {}
    getStores().then(function (stores) {
      self.stores = stores;
      self.geo = resolveQuery(q, stores);
      self.note = '';
      self.render(true);
    }).catch(function () { self.render(true); });
  };

  Panel.prototype.render = function (animate) {
    var self = this;
    var token = (this.renderToken = (this.renderToken || 0) + 1);
    if (!this.stores) {
      this.citySec.content.replaceChildren(el('p', 'mm-stores__empty', 'Loading…'));
      this.countrySec.content.replaceChildren();
    }
    getStores().then(function (stores) {
      if (token !== self.renderToken) return;
      var first = !self.stores;
      self.stores = stores;
      self.paint(animate || first);
    }).catch(function () {
      if (token !== self.renderToken) return;
      var p = el('p', 'mm-stores__empty', 'Stores could not be loaded. ');
      var a = el('a', 'mm-stores__fallback', 'See all stores');
      a.href = '/pages/stockists';
      p.appendChild(a);
      self.citySec.content.replaceChildren(p);
      self.countrySec.content.replaceChildren();
    });
  };

  Panel.prototype.paint = function (animate) {
    var geo = this.geo;
    var stores = this.stores || [];
    var cc = (geo && geo.cc) || (window.Shopify && window.Shopify.country) || '';
    var keys = (geo && geo.keys) || [];

    var inCity = geo ? stores.filter(function (s) { return s.kind === 'city' && keys.indexOf(s.key) >= 0; }) : [];
    var inCountry = cc ? stores.filter(function (s) { return s.cc === cc && inCity.indexOf(s) < 0; }) : [];

    var byCity = function (a, b) {
      var order = { city: 0, multiple: 1, online: 2, none: 3 };
      return (order[a.kind] - order[b.kind]) || a.city.localeCompare(b.city, 'en') || a.title.localeCompare(b.title, 'en');
    };
    inCity.sort(function (a, b) { return a.title.localeCompare(b.title, 'en'); });
    inCountry.sort(byCity);

    this.citySec.where.textContent = geo && geo.city ? geo.city : '';
    this.countrySec.where.textContent = cc ? countryName(cc) : '';

    var cityEmpty = geo ? 'none' : (this.note || (this.hint || 'Tap') + ' “Find your local store” to see stores near you');
    this.fill(this.citySec.content, inCity, cityEmpty, false, animate);
    this.fill(this.countrySec.content, inCountry, 'none', true, animate);
  };

  Panel.prototype.fill = function (target, list, emptyText, showCity, animate) {
    var frag = document.createDocumentFragment();
    if (!list.length) {
      frag.appendChild(el('p', 'mm-stores__empty', emptyText));
    } else {
      var ul = el('ul', 'mm-stores__list');
      list.forEach(function (s, i) {
        var li = el('li', 'mm-stores__item');
        li.style.setProperty('--i', Math.min(i, 14));
        var name = s.link ? el('a', 'mm-stores__name', s.title) : el('span', 'mm-stores__name', s.title);
        if (s.link) { name.href = s.link; name.target = '_blank'; name.rel = 'noopener'; }
        li.appendChild(name);
        var meta = s.kind === 'online' ? 'Online' : s.kind === 'multiple' ? 'Multiple locations' : showCity ? s.city : '';
        if (meta) li.appendChild(el('span', 'mm-stores__meta', meta));
        ul.appendChild(li);
      });
      frag.appendChild(ul);
    }
    target.classList.toggle('is-static', !animate);
    target.replaceChildren(frag);
  };

  /* ---------- desktop: panel slides out next to the burger menu ---------- */
  function DesktopPanel(host) {
    this.host = host;                                     // <burger-menu>
    this.box = host.querySelector('.burger-menu');         // fixed full-screen container
    this.wrapper = host.querySelector('.burger-menu__wrapper');
    this.hint = 'Click';
    this.idPrefix = 'bm';
    this.geo = savedGeo();
    this.build();
    this.bind();
  }
  DesktopPanel.prototype = Object.create(Panel.prototype);
  DesktopPanel.prototype.constructor = DesktopPanel;

  DesktopPanel.prototype.build = function () {
    var root = el('div', 'bm-stores color-background-1');
    root.id = 'bm-stores';
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('role', 'region');
    root.setAttribute('aria-label', 'Find stores');
    var inner = el('div', 'bm-stores__inner');
    this.locateBtn = this.locateButton();
    this.locateBtn.tabIndex = -1;
    inner.appendChild(this.locateBtn);
    inner.appendChild(this.buildBody());
    root.appendChild(inner);
    this.root = root;
    this.box.appendChild(root);
  };

  DesktopPanel.prototype.bind = function () {
    var self = this;
    this.wrapper.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest(TRIGGER);
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      e.stopPropagation();
      self.trigger = a;
      if (self.isOpen) self.close(true); else self.open();
    }, true);
    this.bindFinder();
    // Close together with the burger menu (X, overlay, Escape)
    new MutationObserver(function () {
      if (self.isOpen && !self.box.classList.contains('burger-menu--open')) self.close(false);
    }).observe(this.box, { attributes: true, attributeFilter: ['class'] });
  };

  DesktopPanel.prototype.position = function () {
    var w = this.wrapper.getBoundingClientRect();
    this.root.style.setProperty('--bm-stores-left', Math.round(w.width) + 'px');
    var first = this.wrapper.querySelector('.burger-menu__list-second .burger-menu__item') || this.trigger;
    if (first) {
      var top = first.getBoundingClientRect().top - this.box.getBoundingClientRect().top;
      if (top > 0) this.root.style.setProperty('--bm-stores-top', Math.round(top) + 'px');
    }
  };

  DesktopPanel.prototype.open = function () {
    this.isOpen = true;
    this.position();
    this.root.scrollTop = 0;
    this.box.classList.add('bm-stores-open');
    this.root.setAttribute('aria-hidden', 'false');
    this.locateBtn.tabIndex = 0;
    if (this.trigger) { this.trigger.setAttribute('aria-expanded', 'true'); this.trigger.classList.add('is-active'); }
    var self = this;
    this.render();
    if (!this.geo) {
      permissionGranted().then(function (ok) { if (ok && self.isOpen && !self.geo) self.findMe(); });
    }
  };

  DesktopPanel.prototype.close = function (restoreFocus) {
    this.isOpen = false;
    this.box.classList.remove('bm-stores-open');
    this.root.setAttribute('aria-hidden', 'true');
    this.locateBtn.tabIndex = -1;
    if (this.trigger) { this.trigger.setAttribute('aria-expanded', 'false'); this.trigger.classList.remove('is-active'); }
    if (restoreFocus && this.trigger) { try { this.trigger.focus({ preventScroll: true }); } catch (e) {} }
  };

  /* ---------- init ---------- */
  function init() {
    document.querySelectorAll('mm-mobile-menu').forEach(function (menu) {
      if (menu.__mmStores || !menu.querySelector('.mm-menu__scroll') || !menu.querySelector(TRIGGER)) return;
      menu.__mmStores = new Panel(menu);
    });
    document.querySelectorAll('burger-menu').forEach(function (host) {
      if (host.__mmStores || !host.querySelector('.burger-menu__wrapper') || !host.querySelector('.burger-menu__wrapper ' + TRIGGER)) return;
      host.__mmStores = new DesktopPanel(host);
    });
  }

  function warmCache() {
    var cached = load(LIST_KEY);
    if (cached && Date.now() - cached.t < DAY) return;
    getStores().catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', function () {
    (window.requestIdleCallback || function (fn) { setTimeout(fn, 2000); })(warmCache);
  });
})();
